module.exports = __webpack_public_path__ + "img/imusic.23a8b601.png";